module.exports = __webpack_public_path__ + "img/wheelbackgroundfinal.d48b353b.png";